import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from 'src/app/_services/AuthService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  loggedIn = false;

  constructor(public _authService: AuthServiceService, private _alertify: AlertifyService, private _router: Router) { }

  ngOnInit() {

    this._authService.currentAction.subscribe(action => {
      this.loggedIn = this._authService.loggedIn();
    });

  }

  logout() {
    this._authService.logout();
    this._alertify.message("Logged out");    
    this._router.navigate(['/home']);
    
  }





}
